module.exports = "/static/assets/f89b17149cfcdacfa72f270fe2f90a5f.png";